import { useContext, useEffect, useMemo, useState } from "react";
import { MusicalCreation } from "../../../../../generated/data-contracts";
import { CreationType } from "../../../../../models";
import { api } from "../../../../../utils";
import { AvisLoader } from "../../../../shared/components";
import {
  AvisField,
  AvisGrid,
  AvisSection,
  AvisTitleAndSubtitle,
} from "../../../../shared/components/form";
import { AvisContext } from "../../../../shared/context/AvisContext";
import {
  CreationBands,
  CreationNames,
  CreationNumbers,
  CreationOtherInfo,
  CreationRightsHolders,
} from "../sections";
import { CreationBasePage, ICreationBasePageProps } from "./CreationBasePage";

export function CreationPageMusical(props: Readonly<ICreationBasePageProps>) {
  const { urlParams, setError } = props;
  const { res } = useContext(AvisContext);
  const [creationInfo, setCreationInfo] = useState<
    MusicalCreation | undefined
  >();
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const getCreationInfo = useMemo(() => {
    if (!urlParams.rightsHolderId) return;
    if (!urlParams.creationId) return;
    setIsLoading(true);

    api
      .rightsHoldersGetMusicalCreation(
        urlParams.rightsHolderId,
        urlParams.creationId,
      )
      .then((res) => setCreationInfo(res.data))
      .catch(setError)
      .finally(() => setIsLoading(false));
  }, [urlParams, setError]);

  useEffect(() => {
    getCreationInfo;
  }, [getCreationInfo]);
  if (isLoading) return <AvisLoader inline />;

  return (
    <CreationBasePage data={creationInfo} {...props}>
      <AvisTitleAndSubtitle
        title={creationInfo?.creationName}
        subTitle={creationInfo?.creationGenreName}
      />
      <AvisSection>
        <AvisGrid>
          <AvisField
            title={res("authors_Creation_label_AKKACode")}
            value={creationInfo?.creationNumber}
          />
          <AvisField
            title={res("authors_Creation_label_ISWC")}
            value={creationInfo?.iswcNumber}
          />
          <AvisField
            title={res("authors_Creation_label_Timing")}
            value={creationInfo?.timings}
          />
        </AvisGrid>
      </AvisSection>
      <CreationRightsHolders
        data={creationInfo?.rightsHolders}
        creationType={creationInfo?.creationClassCode as CreationType}
      />
      <CreationBands data={creationInfo?.creationBands} />
      <CreationNames data={creationInfo?.creationNameValues} />
      <CreationNumbers data={creationInfo?.creationNumberValues} />
      <CreationOtherInfo
        creationRegistered={creationInfo?.creationDate}
        creationStatus={creationInfo?.creationStatusNamePortal}
        statusNotes={creationInfo?.statusNotes}
      />
    </CreationBasePage>
  );
}
